import {
    Grid,
    FormControl,
    Select,
    MenuItem,
    InputLabel,
    Accordion,
    AccordionSummary,
    Typography,
    AccordionDetails,
    TextField,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SCUIButton } from '../../../../atomic/atoms';
import { SCUIGeneralDrawerHeader } from '../../../../atomic/molecules';
import { ExpandMore } from '@mui/icons-material';
import { CampaignStatuses, EarningApplicationScopeTypeValues } from '../../../../types/enums/campaign-enums';

export const SCUICampaignSearch = ({ ...props }) => {
    const { campaignService, filterInput, setFilterInput, search, onClose } = props;

    const { assignees, getRulePlatformValuesByRegion } = campaignService;

    const { t } = useTranslation();

    const platforms = getRulePlatformValuesByRegion();
    const applicationScopeTypes = EarningApplicationScopeTypeValues;

    return (
        <form
            onSubmit={async (e: any) => {
                e.preventDefault();
            }}
        >
            <Grid container spacing={1} style={{ justifyContent: 'center' }}>
                <SCUIGeneralDrawerHeader header={t('campaignManagement.search.title')} onClose={onClose} />

                <Grid>
                    <TextField
                        id="inputCampaignName"
                        label={t('campaignManagement.search.campaignName')}
                        value={filterInput.campaignName?.id}
                        variant="outlined"
                        onChange={(event: any) => {
                            const { value } = event.target;
                            setFilterInput({
                                ...filterInput,
                                campaignName: value != '' && value != undefined ? { id: value, name: value } : null,
                            });
                        }}
                        style={{ margin: '5px', width: 410 }}
                    />
                </Grid>

                <Grid>
                    <FormControl style={{ margin: '5px', width: 410 }}>
                        <InputLabel id="labelCampaignType">
                            {t('campaignManagement.search.applicationScopeType')}
                        </InputLabel>
                        <Select
                            labelId="labelCampaignType"
                            id="labelCampaignType"
                            value={filterInput.applicationScopeType?.id}
                            label={t('campaignManagement.search.applicationScopeType')}
                            onChange={(event) => {
                                const { value } = event.target;
                                setFilterInput({
                                    ...filterInput,
                                    applicationScopeType: {
                                        id: value,
                                        name: applicationScopeTypes.find((x) => x.id == parseInt(value))?.name,
                                    },
                                });
                            }}
                        >
                            <MenuItem value="">{t('campaignManagement.search.selectOption')}</MenuItem>
                            {applicationScopeTypes.length > 0 &&
                                applicationScopeTypes.map((item: any) => {
                                    return (
                                        <MenuItem value={item.id} key={item.id}>
                                            {t(item.name)}
                                        </MenuItem>
                                    );
                                })}
                        </Select>
                    </FormControl>
                </Grid>

                <Grid>
                    <FormControl style={{ margin: '5px', width: 410 }}>
                        <InputLabel id="labelStatus">{t('campaignManagement.search.status')}</InputLabel>
                        <Select
                            labelId="labelStatus"
                            id="labelStatus"
                            value={filterInput.status?.id}
                            label={t('campaignManagement.search.status')}
                            onChange={(event) => {
                                const { value } = event.target;
                                setFilterInput({
                                    ...filterInput,
                                    status: {
                                        id: value,
                                        name: CampaignStatuses.find((x) => x.id == parseInt(value))?.name,
                                    },
                                });
                            }}
                        >
                            <MenuItem value="">{t('campaignManagement.search.selectOption')}</MenuItem>
                            {CampaignStatuses.length > 0 &&
                                CampaignStatuses.map((item: any) => {
                                    return (
                                        <MenuItem value={item.id} key={item.id}>
                                            {t(item.name)}
                                        </MenuItem>
                                    );
                                })}
                        </Select>
                    </FormControl>
                </Grid>

                <Grid>
                    <FormControl style={{ margin: '5px', width: 410 }}>
                        <InputLabel id="labelAssignee">{t('campaignManagement.search.assignee')}</InputLabel>
                        <Select
                            labelId="labelAssignee"
                            id="labelAssignee"
                            value={filterInput.assignee?.id}
                            label={t('campaignManagement.search.assignee')}
                            onChange={(event) => {
                                const { value } = event.target;
                                let assignee = {
                                    id: value,
                                    name: assignees.find((x: any) => x.id === value)?.name,
                                };
                                setFilterInput({
                                    ...filterInput,
                                    assignee: assignee,
                                });
                            }}
                        >
                            <MenuItem value="">{t('campaignManagement.search.selectOption')}</MenuItem>
                            {assignees.length > 0 &&
                                assignees.map((item: any) => {
                                    return (
                                        <MenuItem value={item.id} key={item.id}>
                                            {item.name}
                                        </MenuItem>
                                    );
                                })}
                        </Select>
                    </FormControl>
                </Grid>

                <Grid>
                    <FormControl style={{ margin: '5px', width: 410 }}>
                        <TextField
                            id="beginDate"
                            label={t('campaignManagement.search.beginDate')}
                            type="date"
                            value={filterInput.beginDate?.id}
                            slotProps={{
                                inputLabel: {
                                    shrink: true,
                                },
                            }}
                            variant="outlined"
                            onChange={(event) => {
                                const { value } = event.target;
                                setFilterInput({
                                    ...filterInput,
                                    beginDate: value != '' && value != undefined ? { id: value, name: value } : null,
                                });
                            }}
                        />
                    </FormControl>
                </Grid>

                <Grid>
                    <FormControl style={{ margin: '5px', width: 410 }}>
                        <TextField
                            id="endDate"
                            label={t('campaignManagement.search.endDate')}
                            type="date"
                            value={filterInput.endDate?.id}
                            slotProps={{
                                inputLabel: {
                                    shrink: true,
                                },
                            }}
                            variant="outlined"
                            onChange={(event: any) => {
                                const { value } = event.target;
                                setFilterInput({
                                    ...filterInput,
                                    endDate: value != '' && value != undefined ? { id: value, name: value } : null,
                                });
                            }}
                        />
                    </FormControl>
                </Grid>

                <Grid container style={{ justifyContent: 'center' }}>
                    <Grid>
                        <FormControl style={{ margin: '5px' }}>
                            <TextField
                                id="startTime"
                                label={t('campaignManagement.search.startTime')}
                                type="time"
                                defaultValue={filterInput.startTime?.id}
                                value={filterInput.startTime?.id}
                                slotProps={{
                                    inputLabel: {
                                        shrink: true,
                                    },
                                    htmlInput: {
                                        step: 300, // 5 min
                                    },
                                }}
                                style={{ width: '185px' }}
                                variant="outlined"
                                onChange={(event) => {
                                    const { value } = event.target;
                                    setFilterInput({
                                        ...filterInput,
                                        startTime: { id: value, name: value },
                                    });
                                }}
                            />
                        </FormControl>
                    </Grid>
                    <Grid>
                        <FormControl style={{ margin: '5px' }}>
                            <TextField
                                id="endTime"
                                label={t('campaignManagement.search.endTime')}
                                type="time"
                                defaultValue={filterInput.endTime?.id}
                                value={filterInput.endTime?.id}
                                slotProps={{
                                    inputLabel: {
                                        shrink: true,
                                    },
                                    htmlInput: {
                                        step: 300, // 5 min
                                    },
                                }}
                                style={{ width: '185px' }}
                                variant="outlined"
                                onChange={(event) => {
                                    const { value } = event.target;
                                    setFilterInput({
                                        ...filterInput,
                                        endTime: { id: value, name: value },
                                    });
                                }}
                            />
                        </FormControl>
                    </Grid>
                </Grid>

                <Grid style={{ marginBottom: '60px' }}>
                    <Accordion style={{ boxShadow: 'none' }}>
                        <AccordionSummary expandIcon={<ExpandMore />} id="panel1a-header">
                            <Typography>{t('campaignManagement.search.advanceSearch')}</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Grid>
                                <FormControl style={{ margin: '5px', width: 365 }}>
                                    <TextField
                                        id="inputTag"
                                        label={t('campaignManagement.search.tag')}
                                        value={filterInput.tag?.id}
                                        variant="outlined"
                                        onChange={(event) => {
                                            const { value } = event.target;
                                            setFilterInput({
                                                ...filterInput,
                                                tag: { id: value, name: value },
                                            });
                                        }}
                                    />
                                </FormControl>
                            </Grid>

                            {platforms && platforms.length > 1 && (
                                <Grid>
                                    <FormControl style={{ margin: '5px', width: 365 }}>
                                        <InputLabel id="labelPlatform">
                                            {t('campaignManagement.search.platform')}
                                        </InputLabel>
                                        <Select
                                            labelId="labelPlatform"
                                            id="labelPlatform"
                                            value={filterInput.platforms?.at(0)?.id}
                                            label={t('campaignManagement.search.platform')}
                                            onChange={(event) => {
                                                const { value } = event.target;
                                                setFilterInput({
                                                    ...filterInput,
                                                    platforms:
                                                        value != '' && value != undefined
                                                            ? [
                                                                  {
                                                                      id: value,
                                                                      name: platforms.find((x: any) => x.id == value)
                                                                          ?.name,
                                                                  },
                                                              ]
                                                            : null,
                                                });
                                            }}
                                        >
                                            <MenuItem value="">{t('campaignManagement.search.selectOption')}</MenuItem>
                                            {platforms.length > 0 &&
                                                platforms.map((item: any) => {
                                                    return (
                                                        <MenuItem value={item.id} key={item.id}>
                                                            {item.name}
                                                        </MenuItem>
                                                    );
                                                })}
                                        </Select>
                                    </FormControl>
                                </Grid>
                            )}
                        </AccordionDetails>
                    </Accordion>
                </Grid>

                <Grid
                    style={{
                        position: 'fixed',
                        bottom: 0,
                        width: '425px',
                        padding: '0px 10px 25px',
                        backgroundColor: 'white',
                        zIndex: 9999,
                    }}
                >
                    <SCUIButton
                        text={t('campaignManagement.search.searchButton')}
                        type="primary"
                        sizeType="default"
                        size={'s'}
                        fullwidth
                        onClick={search}
                    />
                </Grid>
            </Grid>
        </form>
    );
};
